import React from 'react';
import Layout from 'antd/lib/layout';
// import Footer from '@codex/components/Footer';
var LayoutContainer = function (props) {
    return (React.createElement("div", null,
        React.createElement(Layout, { className: props.classes.root },
            React.createElement(Layout.Content, null, props.children))));
};
export default LayoutContainer;



//////////////////
// WEBPACK FOOTER
// ./src/containers/Layout/Layout.tsx
// module id = 1362
// module chunks = 0